import { GeneralModel } from "./general.model";
import { District } from "./district.model";

export class Ward extends GeneralModel {
    districtId: number;
    district: District;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/ward.model.ts